import { render } from "./Footer.vue?vue&type=template&id=d3792394&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=d3792394&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d3792394"

export default script